<template>
  <div class="news-list-title">
    <h1 class="category-title" :class="{ 'category-title--link': !!categoryId }">
      <router-link
          v-if="categoryId"
          :to="newsListRoute"
          class="pill-btn pill-btn--ghost category-title-link"
      ><span class="back-arrow" aria-hidden="true">←</span>{{ title }}</router-link>
      <template v-else>{{ title }}</template>
    </h1>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useCommonRouteParams } from '../../../composables/useCommonRouteParams';

interface Props {
  title: string;
  categoryId?: string;
}

const props = defineProps<Props>();

let routeParams = useCommonRouteParams();

const newsListRoute = computed(() => {
  if (!props.categoryId) return undefined;
  return {
    name: 'news-list' as const,
    params: {
      nativeLanguage: routeParams.nativeLanguage,
      learnedLanguage: routeParams.learnedLanguage,
      mode: routeParams.mode,
      categoryId: props.categoryId
    }
  };
});
</script>

<style scoped>
.news-list-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.category-title {
  font-size: 36px;
  color: #1F2937;
  margin: 0;
  line-height: var(--line-height-title);
}

.category-title--link {
  font-size: var(--font-size-menu);
  font-weight: 400;
}

.category-title-link {
  text-decoration: none;
}

.category-title-link:hover {
  text-decoration: none;
}

.back-arrow {
  font-size: var(--font-size-menu);
  line-height: 1;
}

@media (max-width: 800px) {
  .category-title {
    font-size: 30px;
  }

  .back-arrow {
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .category-title {
    font-size: 26px;
  }
}
</style>
